/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import useAssessmentHeader from '../../common/hooks/useAssessmentHeader';
import { DefaultQuestionTheme } from '../styles/mfsTheme';
import { RoutePageProps } from '../../base/components/Routes';
import { ThemeProvider } from '@mui/material';
import axios from '../../common/utils/interceptor';
import localizeContentMapper from '../../common/utils/localizeContentMapper';
import { getCookie } from '../../common/utils/cookies';
import { apiUrls, defaultBranding } from '../../constants';
import { currentWorkflowItemProvider } from '../../store/providers/currentWorkflowItemProvider';
import { templateProvider } from '../../store/providers/templateProvider';
import { useAppSelector } from '../../store/hook';

/** HOC for theme */
const withAccessibilityTheme =
  <P extends RoutePageProps>(Component: React.ComponentType<P>): ((props: P) => React.JSX.Element) =>
  (props: P): React.JSX.Element => {
    const tcPlusFlow = getCookie('TcPlusFlag') === '1';
    const template = useAppSelector((state) => state.template);
    const { setTemplate } = templateProvider();
    const { accessibility, selectedTheme } = useAppSelector((state) => state.headerOptions);
    const { companyBranding } = useAppSelector((state) => state.companySettings);
    const { updateCurrentWorkflowItem } = currentWorkflowItemProvider();
    const currentWorkflowItem = useAppSelector((state) => state.currentWorkflowItem);
    const { settings } = template;
    const linkId = `${getCookie('LinkID')}`;

    useAssessmentHeader(true);

    const fetchBasicDetailsByLinkId = async (): Promise<void> => {
      try {
        const { data } = await axios.post(apiUrls.POST_EXPERIENCE_INIT, { link: linkId });
        updateCurrentWorkflowItem(data.currentWorkflowItem);
        if (data.template && data.template.id) {
          // Fallback to default settings in case its null
          const parsedTemplateSettings = data.template.settings ? JSON.parse(data.template.settings) : defaultBranding;
          const updatedTemplate = {
            ...data.template,
            settings: localizeContentMapper(
              tcPlusFlow && companyBranding ? JSON.parse(companyBranding) : parsedTemplateSettings,
              data.template.localizedContentMap,
            ),
          };
          /**
           * update template store and session storage only for new values
           */
          setTemplate(updatedTemplate);
        }
      } catch (error) {
        console.error('Fetch experience init error: ', error);
        if (error && error.data && error.data.message) {
          console.error(error.data.message);
        }
      }
    };

    React.useEffect(() => {
      currentWorkflowItem.id === '0' && fetchBasicDetailsByLinkId();
    }, [currentWorkflowItem]);

    return (
      <ThemeProvider theme={DefaultQuestionTheme(settings, selectedTheme && accessibility[selectedTheme])}>
        <Component {...props} />
      </ThemeProvider>
    );
  };

export default withAccessibilityTheme;
